import { some, keysIn } from 'lodash';
import {
  GLOBAL_TRACKING_KEY,
  SOURCE_ELEMENT_KEY,
  SOURCE_PAGE_KEY,
  SOURCE_TYPE_KEY,
} from '../../../shared/tracking/tealium/constants';
import reportError from '../errorReporter';
import localStorageService from '../../service/localStorage';

const VALID_KEYS = [SOURCE_ELEMENT_KEY, SOURCE_PAGE_KEY, SOURCE_TYPE_KEY];

const findKey = key => VALID_KEYS.indexOf(key) > -1;

const localStorage = localStorageService();

const verifySourceData = (sourceInfo) => {
  const sourceInfoKeys = keysIn(sourceInfo);
  const hasValidKeys = some(sourceInfoKeys, findKey);
  const hasValidValues = !Object.values(sourceInfo).filter(Boolean).some(value => (typeof value !== 'string'));

  return hasValidKeys && hasValidValues;
};

export const setTrackingSource = (params) => {
  if (verifySourceData(params)) {
    const { element, page, type } = params;
    localStorage.setItem(GLOBAL_TRACKING_KEY, JSON.stringify({ element, page, type }));
  } else {
    localStorage.removeItem(GLOBAL_TRACKING_KEY);
    reportError('Failed to set tracking source value to localStorage as the sourceInfo is invalid. The erroneous payload has been supplied as context in this report.', params);
  }
};

export const getTrackingSource = () => {
  const { element, page, type } = localStorage.getJSONValue(GLOBAL_TRACKING_KEY) || {};

  localStorage.removeItem(GLOBAL_TRACKING_KEY);

  return { element, page, type };
};
